const login = {
  "v-tool-bar-title": "Anmeldung Metax IMS",
  "label-email": "Email",
  "label-password": "Passwort",
  "v-btn-login": "Anmeldung"
};
export default login;
